module.exports = __webpack_public_path__ + "img/tips.95bf9fb2.png";